import { useCallback, useMemo } from 'react';
import useInfiniteFetch from '../useInfiniteFetch';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { WDAC_MANAGED_INSTALLER_UNAFFECTED_DEVICES_KEY } from 'src/constants/query';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useQueryParams from '../../hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import ManagedInstallerService from '../../services/managed-installer.service';

const useGetManagedInstallersUnaffectedDevices = ({ managedInstallerId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const {
    queryObject: { searchValue: initialSearchValue, filters = {} },
  } = useQueryParams();

  const query = useMemo(
    () =>
      parseQueryToApiQuery({
        filters,
        searchValue: initialSearchValue,
      }),
    [filters, initialSearchValue],
  );

  const fetchFunction = useCallback(
    ({ page, limit }) =>
      ManagedInstallerService.getManagedInstallersUnaffectedDevices({
        limit,
        page,
        managedInstallerId,
        customerEnvId,
        query,
      }),
    [managedInstallerId, customerEnvId, query],
  );

  const response = useInfiniteFetch({
    queryKey: [
      WDAC_MANAGED_INSTALLER_UNAFFECTED_DEVICES_KEY,
      query,
      customerEnvId,
      managedInstallerId,
    ],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'devices',
  });
  return {
    ...response,
    query,
  };
};

export default useGetManagedInstallersUnaffectedDevices;